import React from 'react';
import { getDateTime } from '../../../utils/common';
import TennisMatchPointsRow from './MatchPoints/TennisMatchPointsRow';
import TennisMatchTieBreakRow from './MatchTieBreak/TennisMatchTieBreakRow';

const TennisMatchTimeLineDetails = ({
  matchTimeLine, timezone, tennisMatchTimelineEvents,
}) => {
  const sets = Object.keys(matchTimeLine);
  return sets?.map((setId) => (
    <React.Fragment key={setId}>
      <div className="table-responsive m-t-30">
        <table className="match">
          <thead className="thead--black">
            <tr>
              <th>{tennisMatchTimelineEvents[setId]}</th>
            </tr>
          </thead>
        </table>
      </div>
      <div className="table-responsive m-t-30">
        <table className="match">
          <thead className="thead--green">
            <tr>
              <th>Game ID</th>
              <th>Game Start Date</th>
              <th>Set Score</th>
              <th className="match-thScore">Info</th>
            </tr>
          </thead>
          <tbody>
            {matchTimeLine[setId].map((match) => {
              const hasWinningPlayer = !!(match.playerOneSetScore === 2
                || match.playerTwoSetScore === 2);
              return (
                <tr key={`col-${match.gameId}`}>
                  <td>{match.gameId}</td>
                  <td>{getDateTime(match.gameStartDate, timezone)}</td>
                  <td>
                    {match.playerOneSetScore}
                    {' '}
                    -
                    {' '}
                    {match.playerTwoSetScore}
                  </td>
                  <td>
                    {match.gameHistory.isTieBreak
                      ? (
                        <TennisMatchTieBreakRow
                          key={match.gameId}
                          gameHistory={match.gameHistory}
                          hasWinningPlayer={hasWinningPlayer}
                        />
                      )
                      : (
                        <TennisMatchPointsRow
                          key={match.gameId}
                          gameHistory={match.gameHistory}
                          hasWinningPlayer={hasWinningPlayer}
                        />
                      )}
                  </td>
                </tr>
              );
            }) }
          </tbody>
        </table>
      </div>
    </React.Fragment>
  ));
};

export default TennisMatchTimeLineDetails;
